import {Component, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';

import {SidebarNavHelper} from '../app-sidebar-nav.service';
import {API} from 'src/shared/apis/api';
import {HttpCustomService} from 'src/service/http-custom.service';
import {take} from 'rxjs/operators';
import {Station} from 'src/shared/model/station';
import {NavDataService} from "../../shared/service/nav-data.service";
import {Subject, Subscription} from "rxjs";
import * as _ from "lodash";
import {CommonConstants} from "../../shared/constants/common-constants.enum";

@Component({
  selector: 'app-sidebar-nav-dropdown, cui-sidebar-nav-dropdown',
  template: `
    <a class="nav-link nav-dropdown-toggle" (click)="click(item.cooperativeNo)"
       appNavDropdownToggle
       [appHtmlAttr]="item.attributes">
      <i *ngIf="helper.hasIcon(item)" [ngClass]="item | appSidebarNavIcon"></i>
      <img *ngIf="helper.hasLogo(item)" [src]="item.logoUrl" class="pr-1">
      <ng-container>{{item.name}}</ng-container>
      <span *ngIf="helper.hasBadge(item)" [ngClass]="item | appSidebarNavBadge">{{ item.badge.text }}</span>
    </a>
    <app-sidebar-nav-items
      class="nav-dropdown-items"
      [items]="item.children">
    </app-sidebar-nav-items>
  `,
  styles: [
    '.nav-dropdown-toggle { cursor: pointer; }',
    '.nav-dropdown-items { display: block; }'
  ],
  providers: [SidebarNavHelper]
})
export class AppSidebarNavDropdownComponent implements OnInit, OnDestroy {
  @Input() item: any;
  ngUnsubscribe: Subject<boolean> = new Subject();
  subscriptions: Subscription[] = [];
  stationList: Station[];
  cooperativeNo: number;

  constructor(
    public helper: SidebarNavHelper,
    private http: HttpCustomService,
    private navDataService: NavDataService,
    private myElement: ElementRef
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.navDataService.refreshChildDataEmitted.takeUntil(this.ngUnsubscribe).subscribe(change => {
    }));
  }

  click(cooperativeNo?: number) {
    const stationNo = localStorage.getItem(CommonConstants.STATION_NO);
    if (cooperativeNo && this.myElement.nativeElement.classList.contains("open") && (_.isNil(stationNo) || stationNo === 'null')) {
      this.cooperativeNo = cooperativeNo;
      this.http.get({path: API.STATION_LIST}, {'cooperative-no': this.cooperativeNo})
        .pipe(take(1)).subscribe(res => {
        this.stationList = res;
        this.item.children = [];
        this.stationList && this.stationList.forEach(station => {
          this.item.children.push({
            name: station.stationCode,
            icon: 'text-success fa fa-circle',
            url: `/meter-cooperative/cooperative/${cooperativeNo}/station/${station.stationNo}/customer`,
          })
        })
      })
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.unsubscribe();
  }

  unsubscribe(): void {
    _.forEach(this.subscriptions, sub => {
      sub.unsubscribe();
    });
    this.subscriptions = [];
  }
}
